// @ts-nocheck
import React from "react"
import styled from "styled-components"
import { Styles, SVGS } from "../../config"


const Vessel = styled.div`
	text-align: center;
	margin: 0;
	& > svg {
		fill: ${(props) => Styles.Color[props.color] || Styles.Color.primary};
		width: ${(props) => Styles.IconSize[props.size] || Styles.IconSize.medium};
		height: ${(props) => Styles.IconSize[props.size] || Styles.IconSize.medium};
		margin: ${(props) => props.margin || 0};
	}
`

const SVG = (props) => {
	return <Vessel {...props}>{React.createElement(SVGS[props.name])}</Vessel>
}

export default SVG
